import type {
    ArchizeenTileProps,
    ObjectShorthandValue,
} from '@archipro-design/aria';
import { ArchizeenTile } from '@archipro-design/aria';
import { useRef } from 'react';
import type {
    AdvertCreative,
    AdEventHandlerOnClick,
} from '@archipro-website/tracker';
import { useAdEventHandler, useTracker } from '@archipro-website/tracker';
import { createLinkedComponentParams } from '~/utils/urlHelper';

type TileProps = ObjectShorthandValue<ArchizeenTileProps> & {
    advertCreative: AdvertCreative;
};

const ArchizeenAdvertTile = (props: TileProps) => {
    const { onClick, advertCreative, ...rest } = props;
    const ref = useRef<HTMLAnchorElement | null>(null);

    const { onClick: adOnClick } = useAdEventHandler(advertCreative, ref);
    const tracker = useTracker();

    const tileOnClick: AdEventHandlerOnClick = (adEventType) => {
        adOnClick(adEventType);
        onClick?.();
    };

    return (
        <ArchizeenTile
            ref={ref}
            {...createLinkedComponentParams(
                tracker,
                'Ad_CTAClick',
                advertCreative.cta.href,
                {
                    libraryItemID: advertCreative.professional.id,
                    professionalID: advertCreative.professional.id,
                    professionalTitle: advertCreative.professional.title,
                },
                null,
                tileOnClick,
            )}
            {...rest}
        />
    );
};

export default ArchizeenAdvertTile;
